<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <button class="btn btn-warning my-2 my-sm-0"
                            @click="showPositionModal(null)"
                            type="button">
                        <icon name="plus"></icon> เพิ่มตำแหน่ง
                    </button>
                    &nbsp;
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ตำแหน่ง</th>
                    <th scope="col">แก้ไข/ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in positionList" >
                    <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                    <td>{{data.name}}</td>
                    <td>
                        <a @click="showPositionModal(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

                <div v-if="positionList.length > 0">
                    <vue-pagination :pagination="dataPaginate"
                                    @paginate="getPositionList">
                    </vue-pagination>
                </div>
        <br>

        <!-- ----Modal Add Social Security---- -->
        <b-modal hide-header hide-footer ref="add_position">
            <div style="text-align: center;">
                <h4>เพิ่มตำแหน่ง</h4>
                <br />
                <div class="row form-group">
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>ตำแหน่ง</label>
                    </b-col>
                    <b-col sm="5" class="col-sm-5">
                        <input v-model="form.name"
                               type="text" class="form-control"/>
                    </b-col>
                </div>

                <button @click="savePosition"
                        type="button"
                        class="btn btn-success mt-2">
                    บันทึก
                </button>
                &nbsp;&nbsp;
                <button
                        type="button"
                        @click="hidePositionModal"
                        class="btn btn-outline-secondary mt-2">
                    ยกเลิก
                </button>
            </div>
        </b-modal>

        <!-- ----Modal delete Social Security---- -->
        <b-modal hide-header hide-footer ref="delete_modal">
            <div style="text-align: center;">
                <h4>คุณต้องการลบสิ่งนี้ใช่หรือไม่?</h4>
                <br />
                <button @click="deletePosition"
                        type="button"
                        class="btn btn-success mt-2">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button
                        type="button"
                        @click="hideDeleteModal"
                        class="btn btn-outline-secondary mt-2">
                    ยกเลิก
                </button>
            </div>
        </b-modal>

<!--        <pre class="alert-primary">{{form}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import Multiselect from "vue-multiselect"
    import VuePagination from "../../../Pagination";
    import moment from "moment";
    import DatePicker from 'vue2-datepicker'

    export default {
        name: "PositionEmployeeList",
        components: {
            Multiselect,
            VuePagination,
            DatePicker
        },
        created(){
            this.$store.dispatch("Position/setPosition");
        },
        data() {
            return {

            };
        },
        computed:{
            ...mapState({
                positionList : state=>{
                    return state.Position.data;
                },
                dataPaginate:state=>{
                    return state.Position.dataPaginate;
                },
                form:state=>{
                    return state.Position.form;
                },
            }),
        },
        methods:{
            hidePositionModal(){
                this.$refs.add_position.hide();
            },
            showPositionModal(id) {
                this.form.id = id

                if(this.form.id!= null){
                    this.$store.dispatch("Position/showPositionByID",this.form.id).then(data =>{
                        this.$refs.add_position.show();
                    });
                }
                else{
                    this.$store.dispatch("Position/clearFormData").then(data =>{
                        this.$refs.add_position.show();
                    });
                }
            },
            hideDeleteModal(){
                this.$refs.delete_modal.hide();
            },
            showDeleteModal(id) {
                this.form.id = id;
                this.$refs.delete_modal.show();
            },
            deletePosition(){
                this.$store.dispatch("Position/delete",this.form.id).then(data =>{
                    this.$store.dispatch("Position/setPosition");
                });
                this.hideDeleteModal();
                this.$store.dispatch("Position/clearFormData");
            },
            savePosition(){
                if(!this.form.name){
                    alert('กรุณากรอกตำแหน่ง')
                }
                else{
                    this.$store.dispatch("Position/savePosition",this.form).then(data =>{
                        this.$store.dispatch("Position/setPosition");
                    });

                }
                this.hidePositionModal();
                this.$store.dispatch("Position/clearFormData");
            },
            getPositionList(){
                const page = this.dataPaginate.current_page;

                    //paginate get data
                this.$store.dispatch("Position/setPosition",page);
            }
        }
    }
</script>

<style scoped>

</style>
